import React from "react";

const BlogCard = (props) => {
  return (
    <section className="i-ideas-elem">
      <img src={props.image} alt="#image" />
      <div className="info">
        <p>{props.info}</p>
      </div>
      <div className="status">
        <span className="status-obj">
          <i class="fa-solid fa-heart"></i>
          <p>{props.like}</p>
        </span>
        <a href={props.link} className="status-obj">
          <i class="fa-solid fa-link"></i>
        </a>
        <span className="status-obj">
          <i class="fa-solid fa-eye"></i>
          <p>{props.see}</p>
        </span>
      </div>
    </section>
  );
};

export default BlogCard;
